/**
 * 平台应用
 */
import * as types from '../types'

const state = {
    currentApp: null
};

const getters = {
    currentApp: state => state.currentApp
};

const actions = {
    changeApp({ commit, state }, appId) {
        commit(types.CHANGE_APP, appId);
        console.log('actions:', appId);
    }
};

const mutations = {
    [types.CHANGE_APP](state, appId) {
        state.currentApp = appId;
        console.log('mutations:', appId);
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/rcapp.js